import AsyncStorage from '@react-native-async-storage/async-storage'

export interface StoredValueWithExpiration<T> {
  value: T
  expires: number
}

export const getStorageItemWithExpiration = async <T>(key: string): Promise<StoredValueWithExpiration<T> | null> => {
  const item = await AsyncStorage.getItem(key)
  if (!item) return null

  const parsedItem: StoredValueWithExpiration<T> = JSON.parse(item)
  if (Date.now() < parsedItem.expires) return parsedItem

  await AsyncStorage.removeItem(key)
  return null
}

export const setStorageValueWithExpiration = async <T>(
  key: string,
  value: T,
  expirationInMs: number,
): Promise<void> => {
  const item: StoredValueWithExpiration<T> = {
    value,
    expires: Date.now() + expirationInMs,
  }

  await AsyncStorage.setItem(key, JSON.stringify(item))
}

export const clearStorageValue = (key: string): Promise<void> => AsyncStorage.removeItem(key)
